<template>
	<div class="card additional-document">
		<div class="container">
			<div
				v-if="!uploaded && !uploadProcess && !uploadError && !errorMaxSize"
				class="row align-items-center additional-document-row"
			>
				<div class="h1 mb-2 icon icon-doc additional-document-icon" />
				<div class="title">
					{{ $t('add') }}
				</div>
				<div class="title">
					<b-form-input
						:value="fileName"
						name="example-input-1"
						aria-describedby="input-1-live-feedback"
						@change="handleChangeName"
					/>
				</div>
				<div class="price-box row justify-content-center">
					<div class="btn btn-primary-outer btn-icon icon-doc document-input-container">
						{{ $t('upload') }}
						<input
							id="file-input"
							:ref="refName"
							class="document-input"
							type="file"
							@change="handleFileUpload"
						>
					</div>
					<div class="btn btn-primary-outer btn-icon icon-cam">
						{{ $t('camera') }}
					</div>
				</div>
			</div>
			<div
				v-if="uploaded && !uploadProcess && !uploadError && !errorMaxSize"
				class="row align-items-center additional-document-row"
			>
				<div class="h1 mb-2 icon icon-doc additional-document-icon" />
				<div>
					{{ fileName }}
				</div>
				<div class="icon-close" @click="handleFileClear" />
			</div>
			<div v-if="uploadProcess" class="row align-items-center additional-document-row">
				<div class="h1 mb-2 icon icon-doc additional-document-icon" />
				<div class="col-10">
					<b-progress max="1" class="mb-3 mt-2" show-progress animated>
						<b-progress-bar value="1" label="загрузка" />
					</b-progress>
				</div>
			</div>
			<div
				v-if="uploadError || errorMaxSize"
				class="row align-items-center additional-document-row"
			>
				<div class="h1 mb-2 icon icon-doc additional-document-icon" />
				<div class="document-upload-error">
					{{ uploadError ? $t('errorUpload') : '' }}
					{{ errorMaxSize && !uploadError ? $t('fileSize') : '' }}
				</div>
				<div class="col-2 icon-close" @click="handleErrorClear" />
			</div>
		</div>
	</div>
</template>

<script>
import { CHECKOUT_STORE_NAMESPACE, MUTATION_SET_FORM_FIELDS_DATA } from '~/store/checkout';

const MAXIMUM_SIZE_FILE = 5 * 1024 * 1024;	// мегабайт

export default {
	name: 'UploadAny',
	props: {
		field: {
			type: Object,
			default: () => {},
		},
		personNumber: {
			type: Number,
			default: 1,
		},
		formData: {
			type: Object,
			default: () => {},
		},
		value: { default: null },
	},
	data() {
		return {
			fileName: this.value,
			uploadProcess: false,
			uploadError: false,
			uploaded: this.value,
			errorMaxSize: false,
		};
	},
	computed: {
		refName() {
			return `file${this.field.field_id}_${this.personNumber}`;
		},
	},
	methods: {
		handleChangeName(fileName) {
			if (fileName) {
				this.fileName = fileName;
			}
		},
		handleErrorClear() {
			this.uploadError = false;
			this.errorMaxSize = false;
		},
		handleFileUpload() {
			const file = this.$refs[this.refName]?.files[0] || '';

			if (!file) {
				return;
			}
			if (file.size >= MAXIMUM_SIZE_FILE) {
				this.errorMaxSize = true;
				return;
			}

			this.fileName = this.fileName || file.name;

			// отправляем документ
			this.uploadProcess = true;
			const formData = { file, form_field_id: this.field.form_field_id };
			this.$api.checkoutFormSaveDocument(formData).then(
				({ data }) => {
					this.uploadProcess = false;
					this.uploaded = true;
					// сохраняем название документа
					this.setStoreData(data.id, data.file.name);
				},
				() => {
					this.uploadProcess = false;
					this.uploadError = true;
					this.handleFileClear();
				},
			);
		},
		handleFileClear() {
			this.fileName = '';
			this.uploaded = false;
			this.$api.checkoutFormRemoveDocument();
			this.setStoreData(null, null);
		},
		setStoreData(imageId, fileName) {
			this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_FIELDS_DATA}`, {
				fields: {
					[this.personNumber]: {
						[this.field.slug]: {
							additionalData: { fileName },
							value: imageId || null,
							personNumber: this.personNumber,
							formFieldId: this.field.form_field_id,
						},
					},
				},
				formId: this.formData.id,
			});

			this.$emit('change');
		},
	},
};
</script>

<style lang="scss" scoped>
    @import "~/assets/styles/components/home/prog-registration";

    .additional-document {
        padding: 20px;
		margin-bottom: 20px;
    }
    .additional-document-row > div + div {
        margin-left: 10px;
    }
    .additional-document-icon {
        position: relative;
        top: 5px;
    }

	.document-input-container {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 5px;
		margin-left: 10px;
	}
	.document-input {
		opacity: 0;
		position: absolute;
		left: 0px;
	}
	.document-upload-error {
		color: red;
	}
</style>
